module.exports = __webpack_public_path__ + "static/media/PositiveSelfAffirmations.8b05d644.png";